import * as z from 'zod/mini';

/**
 * Interface definition for the ConfirmIdentity API, exposed through
 * /api/auth/confirm-identity.
 */
export const confirmIdentityDefinition = z.object({
  request: z.object({
    /**
     * The username for whom the associated identity should be found.
     */
    email: z.string(),
  }),

  response: z.strictObject({
    /**
     * Whether the identify for the requested user could be found.
     */
    success: z.boolean(),

    /**
     * Whether the account associated with that identity has been activated already.
     */
    activated: z.optional(z.boolean()),

    /**
     * When successful, the webauthn options that can be used in the browser.
     */
    options: z.optional(z.any()),
  }),
});

export type ConfirmIdentityDefinition = z.infer<typeof confirmIdentityDefinition>;
